export const isEditable = ({ editable } = {}) => !!editable
export const isRemovable = ({ removable } = {}) => !!removable

export const getText = ({ text } = {}) => text
export const getUser = ({ user } = {}) => user
